import * as types from '../constants/action-types';
export const addError = (requestId, error) => ({
    type: types.ADD_ERROR,
    payload: { requestId, error },
});
export const removeError = (requestId) => ({
    type: types.REMOVE_ERROR,
    payload: requestId,
});
